import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './PracticeAIBuddy.scss';

export const PracticeAIBuddy = () => {
  const navigate = useNavigate();
  const [isMuted, setIsMuted] = useState(false);
  const [time, setTime] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(t => t + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
    const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${h}:${m}:${s}`;
  };

  const handleEndCall = () => {
    navigate('/practice');
  };

  return (
    <div className="practice-ai-buddy text-white d-flex flex-column min-vh-100">
      
      {/* Header */}
      <div className="pa-header d-flex justify-content-between align-items-center p-4">
        <div className="d-flex align-items-center gap-3">
          <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
            <i className="bi bi-robot fs-4"></i>
          </div>
          <div>
            <h5 className="mb-0 fw-bold">Practice Buddy</h5>
            <small className="text-white-50">AI Language Partner</small>
          </div>
        </div>
        
        <div className="d-flex align-items-center gap-4">
          <div className="bg-dark bg-opacity-50 border border-secondary rounded-pill px-3 py-2 d-flex align-items-center gap-2">
            <i className="bi bi-coin text-warning"></i> 7000
          </div>
          <div className="position-relative">
            <div className="bg-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
              <i className="bi bi-person-fill fs-4"></i>
            </div>
            <span className="position-absolute bottom-0 end-0 bg-success border border-dark rounded-circle" style={{ width: '10px', height: '10px' }}></span>
          </div>
        </div>
      </div>

      <Container className="flex-grow-1 d-flex flex-column align-items-center justify-content-center text-center">
        
        <h2 className="fw-bold mb-1">Practice Buddy</h2>
        <p className="text-white-50 mb-4">AI Language Partner</p>

        {/* Status Pill */}
        <div className="bg-dark bg-opacity-50 border border-secondary rounded-pill px-4 py-2 d-flex align-items-center gap-4 mb-5 shadow">
          <div className="d-flex align-items-center gap-2">
            <span className="bg-success rounded-circle" style={{ width: '10px', height: '10px' }}></span>
            <span>Live Conversation</span>
          </div>
          <span className="text-white-50">{formatTime(time)}</span>
        </div>

        {/* AI Robot Graphic */}
        <div className="pa-robot-container position-relative mb-5">
          <div className="pa-glow-ring position-absolute top-50 start-50 translate-middle"></div>
          <div className="pa-robot-avatar position-relative z-1 rounded-circle bg-dark d-flex align-items-center justify-content-center shadow-lg border border-primary border-opacity-50">
            <i className="bi bi-robot text-white" style={{ fontSize: '6rem' }}></i>
          </div>
        </div>

        <h4 className="fw-bold mb-1">Practice Buddy</h4>
        <p className="text-white-50 mb-5">AI Speaking...</p>

        {/* Visualizer (CSS driven) */}
        <div className="pa-visualizer d-flex align-items-center gap-1 mb-5">
          {[...Array(40)].map((_, i) => (
            <div key={i} className="pa-bar bg-primary rounded-pill"></div>
          ))}
        </div>

        {/* Controls */}
        <div className="d-flex gap-5 mt-4">
          <div className="d-flex flex-column align-items-center gap-2">
            <Button 
              variant="outline-light" 
              className={`rounded-circle d-flex align-items-center justify-content-center border-2 ${isMuted ? 'bg-white text-dark' : 'bg-transparent'}`}
              style={{ width: '70px', height: '70px' }}
              onClick={() => setIsMuted(!isMuted)}
            >
              <i className={`bi ${isMuted ? 'bi-mic-mute-fill' : 'bi-mic-fill'} fs-3`}></i>
            </Button>
            <span className="text-white-50 small">Mute</span>
          </div>
          
          <div className="d-flex flex-column align-items-center gap-2">
            <Button 
              variant="danger" 
              className="rounded-circle d-flex align-items-center justify-content-center border-0 shadow-lg"
              style={{ width: '70px', height: '70px', backgroundColor: '#ff3b30' }}
              onClick={handleEndCall}
            >
              <i className="bi bi-telephone-x-fill fs-3"></i>
            </Button>
            <span className="text-white-50 small">End Call</span>
          </div>
        </div>

      </Container>
    </div>
  );
};
